<template lang="pug">
.form-utilities
  h2 更新水电表信息
  template(v-if='!indialog && !$config.logic.manual_meter')
    router-link.ui.themed.button(:to='`/room/${no}/charge`') 空房水电充值
    br
    br
  .ui.four.columns.stackable.grid
    .column(v-for='(utility, index) in utilities')
      utility-view(:key='index', :data='utility' :fallback='room.utilities[index]' :paid='utilities_paid')
      .ui.form
        .ui.field(v-if='!$config.logic.manual_meter')
          label 数字表剩余
          el-input(v-model='utility.balance' type='number' :controls='false')
        .ui.field(v-if='admin')
          label 上次结算度数
          el-input(v-model='utilities_paid[utility.type]' type='number' :controls='false')
        .ui.field
          label 机械表 (上次: {{getPrevMechanical(utility)}})
          el-input(v-model='utility.mechanical' type='number' :controls='false')
  .actions
    .ui.button(@click='save' :class='{disabled:!submitable, themed:submitable}') 保存
    .ui.button(@click='exit') 取消
    el-checkbox(v-model='admin' label='使用管理员权限' style='margin-left:10px')

  template(v-if='!indialog')
    h3 抄表记录
    el-table(:data='history')
      el-table-column(prop='time' label='时间')
      el-table-column(prop='_operator_name' label='操作员')
      el-table-column(prop='water' label='冷水')
      el-table-column(prop='hot_water' label='热水')
      el-table-column(prop='electricity' label='电表')
      el-table-column(prop='kitchen' label='厨房电')
</template>

<script>
/* eslint-disable no-continue */

import moment from 'moment'
import { MakeForm } from '../../utils'
import { UtilityView } from '../basic'

export default {
  name: 'form-utilities',
  components: { UtilityView },
  props: ['no', 'indialog'],

  data() {
    return {
      utilities: [],
      utilities_paid: {},
      admin: true,
    }
  },
  mounted() {
    this.utilities = JSON.parse(JSON.stringify(this.room.utilities))
    this.utilities.forEach(u => {
      u.mechanical = ''
    })
    this.utilities_paid = JSON.parse(JSON.stringify(this.room.utilities_paid || {}))
  },
  computed: {
    room() {
      return this.$store.getters.room(this.no)
    },
    submitable() {
      if (this.admin)
        return true

      let count = 0
      for (const utility of this.utilities) {
        if (utility.mechanical === '')
          continue
        count++
        if (utility.mechanical < this.getPrevMechanical(utility))
          return false
        if (utility.mechanical < this.utilities_paid[utility.type])
          return false
      }
      if (count === 0)
        return false
      return true
    },
    history() {
      return (this.room.utilities_history || [])
        .map(h => {
          const object = {}
          object._operator_name = h._operator_name
          object.time = moment(typeof h.time === 'string' ? h.time : h.time._d).format('YYYY-MM-DD HH:mm')

          for (const u of h.utilities || [])
            object[u.type] = u.mechanical

          return object
        })
        .sort((a, b) => b.time.localeCompare(a.time))
    },
  },
  methods: {
    save() {
      this.submit()
    },
    exit() {
      if (!this.indialog)
        this.$router.back()
      else
        this.$emit('exit')
    },
    getPrevMechanical(utility) {
      const prev = this.room.utilities.find(i => i.type === utility.type)
      if (prev)
        return prev.mechanical

      return 0
    },
    submit: MakeForm({
      type: 'put',
      url() {
        return `rooms/${this.room._id}/utilities`
      },
      confirm: '确定保存水电表信息？',
      payload() {
        const payload = {
          utilities: this.utilities.map(i => {
            const r = { ...i }
            if (!r.mechanical)
              r.mechanical = this.getPrevMechanical(i)
            return r
          }),
          _operator_name: this.$user.get_name(),
        }
        if (this.admin) {
          payload.admin = true
          payload.utilities_paid = this.utilities_paid
        }
        return payload
      },
      loadOnSuccess: 'rooms',
      $onSuccess() {
        this.exit()
      },
    }),
  },
}
</script>



// WEBPACK FOOTER //
// FormUtilities.vue?6a54397e